import type { IComment, ICreateCommentPayload, IUpdateCommentPayload, CommentableType, IPaginatedResponse } from '@/lib/types/comment';
import { axiosInstance } from '@/lib/axios';

interface CommentServiceConfig {
  token?: string;
}

interface GetCommentsParams {
  page?: number;
  per_page?: number;
}

export const commentService = {
  async getComments(
    commentableType: CommentableType, 
    commentableId: number, 
    params?: GetCommentsParams,
    config?: CommentServiceConfig
  ): Promise<IPaginatedResponse<IComment>> {
    const headers = config?.token ? {
      Authorization: `Bearer ${config.token}`
    } : undefined;

    const response = await axiosInstance.get("/api/comments", {
      params: {
        commentable_type: commentableType,
        commentable_id: commentableId,
        page: params?.page || 1,
        per_page: params?.per_page || 10,
      },
      headers
    });
    return response.data;
  },

  async createComment(
    payload: ICreateCommentPayload, 
    config?: CommentServiceConfig
  ): Promise<IComment> {
    const headers = config?.token ? {
      Authorization: `Bearer ${config.token}`
    } : undefined;

    const response = await axiosInstance.post('/api/comments', payload, { headers });
    return response.data.data;
  },

  async updateComment(
    id: number, 
    payload: IUpdateCommentPayload, 
    config?: CommentServiceConfig
  ): Promise<IComment> {
    const headers = config?.token ? {
      Authorization: `Bearer ${config.token}`
    } : undefined;

    const response = await axiosInstance.put(`/api/comments/${id}`, payload, { headers });
    return response.data.data;
  },

  async deleteComment(
    id: number, 
    config?: CommentServiceConfig
  ): Promise<void> {
    const headers = config?.token ? {
      Authorization: `Bearer ${config.token}`
    } : undefined;

    await axiosInstance.delete(`/api/comments/${id}`, { headers });
  },
}; 
